import React from 'react'

class HeaderEmployeeFilter extends React.Component {

    constructor(...args) {
        super(...args);

        this.state = {}
    }

    render() {
        const { schema } = this.props
        return (        
            <div><h4><b>{schema.title}</b></h4></div>
        )
    }
}

export default HeaderEmployeeFilter;



// WEBPACK FOOTER //
// ./src/view/hr/HeaderEmployeeFilter.js